import React, {useState, useMemo, useEffect} from 'react';
import styled from 'styled-components';

import ContentWrapper from 'components/contentWrapper';
import GalleryModal from 'components//galleryModal';

import theme, {bp, color} from 'settings/theme';

import storyblokService from 'services/storyblokService.js';

type Props = {
  product: any,
  showThumbs?: boolean
}

const globalAny:any = global;


const createImageUrl = (origUrl, width) => {
  return origUrl && typeof origUrl === 'string' ? `${origUrl}/m/${width}x0/smart` : '';
};


// Component
const Component: React.FC<Props> = (props) => {


  // Images
  const gallery = props.product?.content?.image_gallery || [];

  const mainImage = gallery[0];

  const thumbs = gallery.length > 1 ? (gallery.length === 4 ? [...gallery].slice(1,4) : [...gallery].slice(1,3)) : [];
  const extraThumbCount = gallery.length > 4 ?  gallery.length - 3 : 0;

  const [galleryState, setGalleryState] = useState({
    slideIndex: 0,
    isOpen: false,
  });

  const openGallery = (e, slideIndex) => {
    setGalleryState({
      slideIndex,
      isOpen: true
    })
  };


  useEffect(() => {

    if(globalAny.ratingSnippet && props?.product?.content?.sku){

      globalAny.ratingSnippet("ruk_rating_snippet",{
        store: "wheelfreedom",  
        color: "#FF9823",  
        linebreak: true,  
        text: "Reviews"  
      })

    }

  }, [props?.product?.content?.sku]);

  return (
    <>

      <StyledComponent className="productHeader paddingVertical">
        <ContentWrapper>

          <div className="productHeader-layout">

            {/* Details */}
            <div className="productHeader-layout-details">
          
              <h1 className="productHeader-title" itemProp="name">{props.product.content.name}</h1>

              {/* Reviews.co.uk */}
              {props?.product?.content?.sku &&
              
                <div className="productHeader-reviews">
                  <div className="ruk_rating_snippet" data-sku={props?.product?.content?.sku}></div>
                </div>
              
              }

              <div className="productHeader-intro" itemProp="description">
                {props.product.content.summary}
              </div>

            </div>

            {/* Images */}
            <div className="productHeader-layout-images">

              <div className="productHeader-images">
                  
                <div className="productHeader-images-main" itemProp="image">
                  {mainImage &&
                    <button onClick={(e) => openGallery(e, 0)}>
                      <img src={storyblokService.createResizedImageUrl(mainImage.image?.filename, 400)} title={mainImage.caption || 'Product Photo'} alt={mainImage.alt_text || 'Product Photo'} />
                    </button>
                  }
                </div>


                {props.showThumbs && thumbs.length > 0 &&
                
                  <div className="productHeader-images-thumbs">
                      
                    {thumbs.map((item, index) => (
                      <button onClick={(e) => openGallery(e, index + 1)} key={item._uid}>
                        <div className="productHeader-images-thumb">
                          <img src={storyblokService.createResizedImageUrl(item.image?.filename, 200)} title={item.caption || 'Product Photo'} alt={item.alt_text || 'Product Photo'} />
                        </div>
                      </button>
                    ))}

                    {extraThumbCount > 0 &&
                      <div className="productHeader-images-thumb productHeader-images-thumb--number">
                        <button onClick={(e) => openGallery(e, 3)}>
                          <div>+{extraThumbCount}</div>
                          <div>more</div>
                        </button>
                      </div>
                    }

                  </div>
                  
                  }
                  
              </div>

            </div>

          </div>

        </ContentWrapper>
      </StyledComponent>


      {galleryState.isOpen && (

        <GalleryModal
          currentSlide={{
            type: 'image',
            src: createImageUrl(gallery[galleryState.slideIndex].image.filename, 640),
            title: gallery[galleryState.slideIndex].caption || 'Product Photo',
            alt_text: gallery[galleryState.slideIndex].alt_text || 'Product Photo'
          }}
          onCloseRequest={() => setGalleryState({ slideIndex:0, isOpen:false })}
          onMovePrevRequest={() =>
            setGalleryState({
              slideIndex: (galleryState.slideIndex + gallery.length - 1) % gallery.length,
              isOpen: galleryState.isOpen
            })
          }
          onMoveNextRequest={() =>
            setGalleryState({
              slideIndex: (galleryState.slideIndex + 1) % gallery.length,
              isOpen: galleryState.isOpen
            })
          }
        ></GalleryModal>

      )}

    </>

  ); 

}

Component.defaultProps = {
  showThumbs: true
};

export default Component;




// Styles
const StyledComponent = styled.div`

  background-color: white;

  .productHeader-layout{
    display: flex;
    flex-direction: column;
  }

  .productHeader-layout-details{
    margin-bottom: 20px;
  }

  h1{
    font-size: 20px;
    font-weight: normal;
  }

  .productHeader-reviews{

    display: flex;
    align-items: center;
    margin-top: 0.3rem;

    .productHeader-reviews-stars{

      position: relative;
      top: -1px;
      white-space: nowrap;

      .icon{

        width: 18px;
        height: 18px;

        svg{
          fill: ${color.orange(50)};
        }

      }

    }

    .productHeader-reviews-count{
      margin-left: 10px;
      color: ${color.grey(20)};
      font-size: 12px;
    }

  }

  .productHeader-intro{
    display: none;
  }


  .productHeader-images{
    display: flex;
    max-width: 500px;
  }

  .productHeader-images-main{
    
    flex: 1 1 auto;
    width: 75%;
    margin-right: 16px;

    img{width: 100%;}

  }

  .productHeader-images-thumbs{

    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    flex: 0 0 auto;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 22.5%;
    margin-left: 8px;

    .productHeader-images-thumb{
      img{width: 100%;}
    }

    .productHeader-images-thumb--number{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 33%;
      font-size: 16px;
      line-height: 1.1;
    }

  }


  @media (min-width: ${bp(3)}) {

    h1{
      font-size: 32px;
    }

    .productHeader-reviews{

      margin-top: 0.5rem;

      .productHeader-reviews-count{
        margin-left: 10px;
        font-size: 14px;
      }

    }

    .productHeader-intro{
      display: block;
      padding-top: 1rem;
      font-size: 15px;
    }

  }

  @media (min-width: ${bp(4)}) {

    .productHeader-layout{
      flex-direction: row;
    }

    .productHeader-layout-details{
      width: 70%;
      margin-right: 30px;
    }

    .productHeader-layout-images{
      display: flex;
      align-items: center;
      width: 30%;
    }

  }

`;



